import { render, staticRenderFns } from "./DemoT.vue?vue&type=template&id=f8bcacae"
import script from "./DemoT.vue?vue&type=script&lang=js"
export * from "./DemoT.vue?vue&type=script&lang=js"
import style0 from "./DemoT.vue?vue&type=style&index=0&id=f8bcacae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports